// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3U7RM","list":"PatternAutocomplete_list__2ZnGq"};